export default __webpack_public_path__ + "icon-arrow-down-hover.png?dd8884c5c166e01b1f8ede3a773f456a";